const PaymentPlanType = {
    FIXED_INSTALLMENT_LOAN: "FIXED_INSTALLMENT_LOAN",
    NO_INTEREST: "NO_INTEREST",
    SUB_LENDER_PROMOTIONAL_RATE: "SUB_LENDER_PROMOTIONAL_RATE",
    SUB_LENDER_NO_INTEREST: "SUB_LENDER_NO_INTEREST",
    SUB_LENDER_FIXED_LOAN: "SUB_LENDER_FIXED_LOAN"
}

export default PaymentPlanType
